import { LitElement, TemplateResult, css, html } from 'lit'
import { customElement, property } from 'lit/decorators'
import { voyageSuggestedStyles } from './helper'
import { AlignStarRouteEvents } from './types'

@customElement('align-star-route-modal')
export class AlignStarRouteModal extends LitElement {
    @property({ attribute: false }) _selectedRouteId: string = ""

    modalContent?: TemplateResult<1>;

    private _handleClose() {
        this.dispatchEvent(
            new CustomEvent(AlignStarRouteEvents.AlignStarRouteModalClick, {
                detail: { id: '' },
            }),
        )
    }

    private _handleEdit() {
        const selectedCard = this.shadowRoot?.querySelector('.route-card-items.selected');
        const selectedRouteId = selectedCard?.getAttribute('id');
        if(selectedRouteId){
            this.dispatchEvent(
                new CustomEvent(AlignStarRouteEvents.AlignStarRouteModalClick, {
                    detail: { id: selectedRouteId },
                }),
            )
        }
    }

    static get styles() {
        return [
            css`
                .modal-content {
                    overflow-x: scroll;
                    white-space: nowrap;
                    width: max-content;
                    margin-bottom: 20px;
                    max-width: 1200px;
                    place-items: center;
                    display: grid;
                }
                .button-container {
                    display: flex;
                    justify-content: flex-end;
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                }
                .continue-button {
                    margin-left: 10px;
                }
                .sub-heading {
                    margin-bottom: 10px;
                    width: 100%;
                }
                .container-buttons{
                    margin: 10px
                }
                .route-card-items {
                    cursor: pointer;
                    border: 2px solid var(--neutrals-grey-06, grey);
                    font-family: MaerskText;
                    align-items: center;
                    border-radius: 4px;
                    padding: 0px 16px;
                    margin-bottom: 8px;
                    width:350px !important
                }
                .route-card-items.selected {
                    border: 2px solid var(--selected-border-color);
                    background-color: var(--selected-background-color);
                }
            `,
            voyageSuggestedStyles,
        ]
    }

    render() {
        return html` <mc-modal
            heading="Align to Star Route"
            ?open=${true}
            height="auto"
            fit="medium"
            dimension="medium"
            width="100%"
            hiddenfooter
            backdropcloseactiondisabled
            escapecloseactiondisabled
            entercloseactiondisabled
            @closing=${this._handleClose}
            ><div class="modal-content">
                <div class="sub-heading">
                    Please choose a StarRoute from the lists provided below:
                </div>
                ${this.modalContent}
               
            </div>
            <div class="container-buttons">
            <div class="button-container">
                    <mc-button variant="outlined" @click=${this._handleClose}
                        >Cancel</mc-button
                    >
                    <mc-button
                        variant="filled"
                        class="continue-button"
                        @click=${()=>this._handleEdit()}
                        >Continue</mc-button
                    >
                </div></div>
        </mc-modal>`
    }
}
